import axios from 'axios';

// Shared axios instance configured in store/index.js (baseURL, timeout, interceptors).
const http = axios.create();

export default http;
